module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "size": "sm",
      "data-dismiss": "modal"
    },
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Adicionando Imagens")]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "columns": 12,
      "label": "Variações"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.variations,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Selecione",
      "custom-label": _vm.variationTitle,
      "track-by": "sku",
      "multiple": true
    },
    model: {
      value: (_vm.selectedVariations),
      callback: function($$v) {
        _vm.selectedVariations = $$v
      },
      expression: "selectedVariations"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Imagem",
      "columns": 12
    }
  }, [_c('upload-image', {
    attrs: {
      "module": {
        type: 'erp',
        identifier: 'tiny'
      }
    },
    on: {
      "file": _vm.uploadedImage
    }
  })], 1)], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn btn--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Adicionar")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31430718","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/Edit/Api/ModalAddImage.vue
// module id = 3030
// module chunks = 0